import { render, staticRenderFns } from "./ModalSend.vue?vue&type=template&id=9fb0c144&scoped=true&"
import script from "./ModalSend.vue?vue&type=script&lang=ts&"
export * from "./ModalSend.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSend.vue?vue&type=style&index=0&id=9fb0c144&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb0c144",
  null
  
)

export default component.exports